import React from 'react';

interface AuthPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

export default function AuthPageLayout({ title, children }: AuthPageLayoutProps) {
  return (
    <main className="mx-auto mt-12 w-full max-w-md px-4">
      <div className="rounded-xl border border-border bg-card p-6 text-card-foreground shadow-sm">
        <p className="mb-2 text-sm font-medium text-muted-foreground">FluxHive console</p>
        <h1 className="mb-6 font-heading text-2xl font-semibold">{title}</h1>
        {children}
      </div>
    </main>
  );
}
